import React from 'react';
import { Card, CardHeader, DialogActions, Divider, Flex, Heading, IconInfoOutline, Paragraph, Popover, Popper, Spacer, Text, TextButton, TriggerText } from '@zillow/constellation';

var DtsPropertyBlock = function DtsPropertyBlock(props) {
  // TODO: Search property information based on zpid
  var popoverTitle = props.popoverTitle,
      popoverContent = props.popoverContent,
      header = props.header,
      address = props.address,
      withShowcaseLabel = props.withShowcaseLabel,
      withoutShowcaseLabel = props.withoutShowcaseLabel,
      withShowcaseAmount = props.withShowcaseAmount,
      withoutShowcaseAmount = props.withoutShowcaseAmount,
      totalEarnings = props.totalEarnings,
      footerText = props.footerText;
  var popover = /*#__PURE__*/React.createElement(Popover, {
    modal: false,
    renderHeader: /*#__PURE__*/React.createElement(Heading, {
      level: "6"
    }, popoverTitle),
    renderBody: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, null, popoverContent), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(TextButton, {
      as: "a",
      target: "_blank",
      href: "https://showingtimeplus.com/showcase-facts"
    }, "Learn more")))
  });
  return /*#__PURE__*/React.createElement(Card, {
    cardType: "secondary",
    cardElevation: 1,
    style: {
      width: '100%',
      borderRadius: '16px',
      padding: '0px'
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    style: {
      backgroundColor: '#E0F2FF',
      textAlign: 'center',
      fontSize: '16px',
      borderRadius: '16px 16px 0px 0px',
      verticalAlign: 'middle',
      padding: '12px',
      marginBottom: '0px'
    }
  }, header), /*#__PURE__*/React.createElement(Flex, {
    style: {
      padding: '0px 10px'
    }
  }, /*#__PURE__*/React.createElement(Spacer, {
    margin: "md"
  }), /*#__PURE__*/React.createElement(Text, {
    style: {
      fontWeight: 400,
      color: '#596B82'
    }
  }, address), /*#__PURE__*/React.createElement(Spacer, {
    margin: "sm"
  }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Spacer, {
    margin: "sm"
  }), /*#__PURE__*/React.createElement(Spacer, {
    margin: "sm"
  }), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "xs"
  }, /*#__PURE__*/React.createElement(Text, null, withoutShowcaseLabel), /*#__PURE__*/React.createElement(Text, null, withoutShowcaseAmount)), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Popper, {
    triggered: popover
  }, /*#__PURE__*/React.createElement(TriggerText, {
    style: {
      fontWeight: 'bold',
      color: '#0D4599',
      fontFamily: 'Open Sans',
      borderBottom: 'none'
    }
  }, withShowcaseLabel)), /*#__PURE__*/React.createElement(Text, {
    style: {
      fontWeight: 'bold'
    }
  }, withShowcaseAmount))), /*#__PURE__*/React.createElement(Spacer, {
    paddingBottom: "sm"
  }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Spacer, {
    paddingBottom: "sm"
  }), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "3",
    "data-testid": "dts-price-value",
    style: {
      color: '#128A29'
    }
  }, totalEarnings)), /*#__PURE__*/React.createElement(Spacer, {
    margin: "md"
  }), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(IconInfoOutline, {
    size: "sm",
    style: {
      margin: '5px 10px'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    "data-testid": "dts-footer-info",
    style: {
      color: '#596B82',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '16px'
    }
  }, footerText)), /*#__PURE__*/React.createElement(Spacer, {
    margin: "md"
  })));
};

export default DtsPropertyBlock;
//# sourceMappingURL=DtsPropertyBlock.js.map